export default __webpack_public_path__ + "static/media/920.6e582833.jpg";